
import themes from "@/mixins/themes"
import JobPageTags from "@/components/job/jobpage/JobPageTags"

export default {
    name: "JobPageOverviewInfo",
    components: { JobPageTags },
    mixins: [themes],
    props: {
        /** Job object */
        job: {
            type: Object,
            required: true,
        },
        /** Enables desktop layout */
        desktop: {
            type: Boolean,
            default: false,
        },
        /** Hides tags */
        hideTags: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        jobTypeName() {
            switch (this.job.type_id) {
                case 1:
                    return "Ausbildung"
                case 2:
                    return "Praktikum"
                case 3:
                    return "Job"
                default:
                    console.warn("Error: unrecognizable job type")
                    return ""
            }
        },
    },
}
